import React, { useContext, useEffect, useState, lazy } from 'react'
import { HashRouter, BrowserRouter, Route, Switch } from 'react-router-dom'
import { Query } from 'react-apollo'

import { GET_ERRORS } from './graphql/queries'
const SearchResults = lazy(() => import('./routes/SearchResults'))
import Modal from './components/Modal/Modal'
import Confirm from './components/SingleName/Confirm'
import { NetworkError, Error404 } from './components/Error/Errors'
import { CONFIRM } from './modals'
import ExpiryNotificationModal from './components/ExpiryNotification/ExpiryNotificationModal'

import { setup as setupAnalytics } from './utils/analytics1'
import StackdriverErrorReporter from 'stackdriver-errors-js'
import GlobalState from './globalState'
import { ApolloProvider } from 'react-apollo'
import { setupClient } from 'apolloClient'

import Home from './components/Home/home'
import AffliatePage from 'components/Affliate'
import Searchdomain from './components/Search/search'
import RequestRegister from './components/RequestRegister/requestRegister'
import RequestRegister2 from './components/RequestRegister2/requestRegister2'
import SearchThirdStep from './components/SearchThirdStep/searchThirdStep'
import TransferData from './components/TransferData/transferData'
import RejectedPage from './components/RejectedPage/rejectedPage'
import SearchStart from './components/SearchStart/searchStart'
import BulkResult from './components/BulkResult/bulkResult'
import ListReject from './components/ListReject/listReject'
import Faq from './components/FAQ/faq'
import Contact from './components/Contact/contact'
import Learn from './components/Learn/learn'
import Avaxpricing from './components/AvaxPricing/avaxpricing'
import MainPanel from 'components/MainPanel'
import LearnArticle from 'components/Learn/learnArticle'
import Account from './components/Account'
import TermsOfUse from './components/TermsOfUse'
import { useLocale } from 'hooks'
import { useTranslation } from 'react-i18next'
import PrivacyAndPolicy from 'components/PrivacyAndPolicy'
import { hotjar } from 'react-hotjar'

const errorHandler = new StackdriverErrorReporter()

// If we are targeting an IPFS build we need to use HashRouter
// const TRACKING_ID = process.env.REACT_APP_GA_TRACKING_ID
const HOTJAR_ID = process.env.REACT_APP_HOT_JAR_ID
const Router =
  process.env.REACT_APP_IPFS === 'True' ? HashRouter : BrowserRouter

// ReactGA.initialize(TRACKING_ID)

const App = ({ initialClient, initialNetworkId }) => {
  const { currentNetwork } = useContext(GlobalState)
  let [currentClient, setCurrentClient] = useState(initialClient)
  const { locale } = useLocale()
  const { i18n } = useTranslation()
  useEffect(() => {
    if (currentNetwork) {
      setupClient(currentNetwork).then(client => setCurrentClient(client))
    }
  }, [currentNetwork])

  useEffect(() => {
    i18n.changeLanguage(locale)
  }, [locale])

  useEffect(() => {
    hotjar.initialize(HOTJAR_ID)
  }, [])
  return (
    <ApolloProvider client={currentClient}>
      <Query query={GET_ERRORS}>
        {({ data }) => {
          setupAnalytics()
          errorHandler.start({
            key: 'AIzaSyDW3loXBr_2e-Q2f8ZXdD0UAvMzaodBBNg',
            projectId: 'idyllic-ethos-235310'
          })

          if (data && data.error && data.error.message) {
            return <NetworkError message={data.error.message} />
          } else {
            return (
              <>
                <Router>
                  <MainPanel>
                    <Switch>
                      <Route exact path="/">
                        <Home />
                      </Route>
                      <Route exact path="/name/:name">
                        <Searchdomain />
                      </Route>
                      <Route exact path="/name/:name/:tab">
                        <Searchdomain />
                      </Route>
                      <Route path="/requestRegister">
                        <RequestRegister />
                      </Route>
                      <Route path="/requestRegister2">
                        <RequestRegister2 />
                      </Route>
                      <Route path="/searchThirdStep">
                        <SearchThirdStep />
                      </Route>
                      <Route path="/transferData">
                        <TransferData />
                      </Route>
                      <Route path="/rejectedPage">
                        <RejectedPage />
                      </Route>
                      <Route path="/searchStart">
                        <SearchStart />
                      </Route>
                      <Route path="/bulkResult">
                        <BulkResult />
                      </Route>
                      <Route path="/listReject">
                        <ListReject />
                      </Route>
                      <Route path="/faq">
                        <Faq />
                      </Route>
                      <Route path="/contact">
                        <Contact />
                      </Route>
                      <Route exact path="/learn">
                        <Learn />
                      </Route>
                      <Route path="/learn/:articleId">
                        <LearnArticle />
                      </Route>
                      <Route path="/avaxpricing">
                        <Avaxpricing />
                      </Route>
                      <Route path="/search/:searchTerm">
                        <SearchResults />
                      </Route>
                      <Route path="/account">
                        <Account />
                      </Route>
                      <Route path="/privacy-and-policy">
                        <PrivacyAndPolicy />
                      </Route>
                      <Route path="/affliate">
                        <AffliatePage />
                      </Route>
                      <Route path="/terms-of-use">
                        <TermsOfUse />
                      </Route>
                      <Route path="*" component={Error404} />
                    </Switch>
                  </MainPanel>
                </Router>
                <Modal name={CONFIRM} component={Confirm} />
                <ExpiryNotificationModal />
              </>
            )
          }
        }}
      </Query>
    </ApolloProvider>
  )
}
export default App
